module.exports = __webpack_public_path__ + "static/media/select_programMobile.e835d8e5.jpg";